import store from '../store'

//黄姚平台禁用菜单
function getHuangYaoConfig() {
  return [
    'DestinationList',//目的地
    'Market',//装修市场
    'MyTemplate',//我的模版
    'MovePort',//H5移动端
    'VersionDescription',//版本说明
    'PcWeb'//PC网站
  ]
}

//(平台)禁用菜单配置文件
const platformConfig = [
  {
    platformTag: 'huangYao',
    getConfig: () => getHuangYaoConfig()
  }
]

//通过平台Id获取禁用菜单
function getDisableMenusByTag(platformTag) {
  if (platformTag) {
    let findItem = platformConfig.find(item => item.platformTag === platformTag)
    if (findItem) {
      return findItem.getConfig()
    }
  }
  return []
}

//获取禁用菜单
export default function getDisableMenuList() {
  let platformConfig = store.getters.platformConfig
  let platformTag = platformConfig.platformTag
  return getDisableMenusByTag(platformTag)
}